import { Watch } from "react-loader-spinner";
import "./LoaderStyle.css";

const Loader = () => {
  return (
    <div className="loader-wrapper">
      <Watch
        height="80"
        width="120"
        radius="48"
        color="#38b5ec"
        ariaLabel="watch-loading"
        visible={true}
      />
    </div>
  );
};
export { Loader };
